import axios from "axios";
import { baseUrl } from "../utils/baseUrl";

const userInstance = axios.create({
    baseURL: `${baseUrl}/api/User`,
    headers: {
        "Content-Type": "application/json",
    },
});

export default userInstance;
